import { QueryKey } from "@tanstack/react-query";
import { GetServiceTicketParams } from "./service-ticket.types";

export const SERVICE_TICKET_KEYS = {
  SERVICE_TICKET: "service-ticket",
  GET_SERVICE_TICKETS: (params?: GetServiceTicketParams): QueryKey => [
    SERVICE_TICKET_KEYS.SERVICE_TICKET,
    "list",
    params,
  ],
  GET_SERVICE_TICKET: (id: string): QueryKey => [
    SERVICE_TICKET_KEYS.SERVICE_TICKET,
    id,
  ],
  GET_MY_SERVICE_TICKETS: (params?: GetServiceTicketParams) => [
    `${SERVICE_TICKET_KEYS.SERVICE_TICKET}/myServices`,
    params,
  ],
  GET_MY_SERVICE_TICKETS_INFINITE: (params?: GetServiceTicketParams) => [
    `${SERVICE_TICKET_KEYS.SERVICE_TICKET}/myServices/infinite`,
    params,
  ],
  GET_UPCOMING_SERVICE_TICKETS_BY_INVENTORY_ID: (inventoryId: string, params?: GetServiceTicketParams): QueryKey => [
    "service-tickets", "by-inventory", inventoryId, params
  ],
  GET_HISTORY_SERVICE_TICKETS_BY_INVENTORY_ID: (inventoryId: string, params?: GetServiceTicketParams): QueryKey => [
    "service-tickets", "history-by-inventory", inventoryId, params
  ],
  GET_SERVICE_TICKET_INVENTORIES: (id: string): QueryKey => [
    SERVICE_TICKET_KEYS.SERVICE_TICKET,
    `${id}/inventories`,
  ],
  // Expo Mode Keys
  GET_EXPO_DAYS: (serviceTicketId: string): QueryKey => [
    SERVICE_TICKET_KEYS.SERVICE_TICKET,
    serviceTicketId,
    "expo-days",
  ],
  GET_AVAILABLE_POSITIONS: (): QueryKey => [
    SERVICE_TICKET_KEYS.SERVICE_TICKET,
    "expo",
    "positions",
  ],
};
